import { Controller } from "@hotwired/stimulus"

import { formatToTimeZone } from "date-fns-timezone"

export default class extends Controller {
  static targets = ["clock"]
  static values = {
    zone: {
      type: String,
      default: "Europe/Rome"
    }
  }

  connect() {
    this.updateClock()
  }

  updateClock() {
    const date = new Date
    const format = "HH:mm"
    const output = formatToTimeZone(date, format, { timeZone: this.zoneValue })

    this.clockTarget.innerHTML = output

    const t = setTimeout(() => this.updateClock(), 1000);
  }
}
